module.exports = __webpack_public_path__ + "static/assets/c9cdaf7300f1d67200c1f0ad99c80a4e.png";